import dayjs from 'dayjs';
import { initializeApollo, addApolloState } from '~/lib/apollo/apolloClient';
import { REDIRECT_URL_QUERY } from '~/queries/REDIRECT_URL_QUERY.gql';
import config from '~/config';

async function getRedirectUrl({ id, siteHandle }) {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.query({
    query: REDIRECT_URL_QUERY,
    variables: { siteHandle, id },
  });

  return data.entry ? data.entry : null;
}

export const cmsDataService = {
  getSiteHandle(locale) {
    const lang = locale;
    const matchedLocale = config.sites.find(site => site.locale === lang);

    if (!matchedLocale) {
      console.error('No matching locale found');
      return;
    }

    dayjs.locale(matchedLocale.locale);
    return matchedLocale.handle;
  },

  // url is for the redirects on 404s
  async getPageProps({ ctx, queries, url }) {
    const apolloClient = initializeApollo();
    let headers;

    const { preview, previewData } = ctx;

    if (preview) {
      headers = { 'X-Craft-Token': previewData?.previewToken };
    }

    const data = await Promise.all(
      queries.map(async ({ query, variables }) => {
        const siteHandle = this.getSiteHandle(ctx.locale);
        const { data: queryData } = await apolloClient.query({
          query,
          variables: {
            ...variables,
            siteHandle,
          },
          context: { headers },
        });

        if ('entry' in queryData && !queryData.entry && variables.id) {
          const { id } = variables;

          const response = await getRedirectUrl({ id, siteHandle });

          if (response && response.url) {
            return { redirect: { permanent: true, destination: response.url } };
          }
          return { notFound: true };
        }

        if ('entry' in queryData && !queryData.entry) {
          const response = await fetch(process.env.hosts.be + '/api/v1/redirects/find', {
            method: 'POST',
            body: JSON.stringify({
              url,
            }),
          });

          if (response.status === 200) {
            const body = await response.json();
            return { redirect: { permanent: body.type === '301', destination: body.url } };
          }

          return { notFound: true };
        }

        return queryData;
      })
    );

    if ('entry' in data[0]) {
      return addApolloState(apolloClient, {
        props: {
          initialApolloState: apolloClient.cache.extract(),
          preview: preview || false,
          ...queries[0].variables,
        },
      });
    }
    return data[0];
  },
};
